<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      initialValues: {
        page_label_pl: 'Zobacz wydarzenie',
        share_label_pl: 'Udostępnij wydarzenie'
      }
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tekst linku do strony',
              modelPath: [this, 'form', 'page_label'],
              required: true,
              multilingual: true
            }),
            new fields.Input({
              label: 'Tekst udostępnienia',
              modelPath: [this, 'form', 'share_label'],
              required: true,
              multilingual: true
            }),
            new fields.Input({
              label: 'Link do facebooka',
              modelPath: [this, 'form', 'facebook_url'],
              required: true
            })
          ]
        }
      ]
    }
  }
}
</script>
